"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var utils_1 = require("./utils");

var defaultOptions = {
  storeKey: utils_1.defaultStoreKey,
  store: undefined
};

function createProvider(options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var _a;

  var _b;

  var _c = __assign({}, defaultOptions, options),
      storeKey = _c.storeKey,
      store = _c.store;

  return _b =
  /** @class */
  function (_super) {
    __extends(Provider, _super);

    function Provider() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    Provider.prototype.getChildContext = function () {
      var _a;

      return _a = {}, _a[storeKey] = this.props.store || store, _a;
    };

    Provider.prototype.render = function () {
      return React.Children.only(this.props.children);
    };

    return Provider;
  }(React.Component), _b.childContextTypes = (_a = {}, _a[storeKey] = function () {}, _a), _b;
}

exports.default = createProvider;